import data from '../../../../data/basic.json';

export class PreloadPicsController {
    constructor() {
        this._imageSlides = [...document.querySelectorAll('.mobile-map-container .slide')];
    }

    init() {
        this._imageSlides.forEach((slide, slideIndex) => {
            const image = new Image();
            image.src = data.mobileslides[slideIndex];
            slide.setAttribute('style', `background-image: url(${image.src});`);
        });
    }
}
